import * as Yup from "yup";
import { CONTAINER_ID_PREFIX } from "../../../../../utils/parts";
import { OBJECT_ID_REGEX } from "../../../../../utils/forms";
import { ContainerAllocation } from "../../../../../reducers/componentSearch";

export const FLASHPCB_CONTAINER_BARCODE_REGEX = new RegExp(
  `(^${CONTAINER_ID_PREFIX}${OBJECT_ID_REGEX}$)`,
);

export interface ContainerDetailsFormValues {
  containerType: string;
  lastCountedAmount: number;
  nickname: string;
  notes: string;
  unitPrice: number;
  vendor: string;
  orderDate: string;
  moistureSensitivityLevel: string;
  flashpcbContainerBarcode: string;
  flashpcbBinBarcode: string;
  allocations: ContainerAllocation[];
  spentAllocations: ContainerAllocation[];
  lotNumber: string;
  countryCode: string;
  dateCode: string;
  reelWidthMM: number;
  reelPitchMM: number;
  partPlacementType: string;
}

export const baseContainerSchema = Yup.object().shape({
  notes: Yup.string(),
  unitPrice: Yup.number()
    .required("Unit price is required")
    .moreThan(0, "Unit price must be positive"),
  vendor: Yup.string(),
  orderDate: Yup.string(),
  flashpcbContainerBarcode: Yup.string()
    .required("FlashPCB container barcode is required")
    .matches(new RegExp(FLASHPCB_CONTAINER_BARCODE_REGEX)),
  reeWidthMM: Yup.number().nullable(),
  reelPitchMM: Yup.number().nullable(),
  partPlacementType: Yup.string().nullable(),
});
